module.exports = __webpack_public_path__ + "img/infrastructureOperationAndMaintenance.9063676e.svg";